/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'gemini/lib/@waca/dashboard-common/dist/core/APIFactory',
	'./PerformanceAPI'
], function (APIFactory, PerformanceAPI) {

	class Performance {

		constructor({ features }) {
			this._ipaActive = false;
			this._features = features;
		}

		isEnabled() {
			return this._features['Dashboard.DashboardSettings'].get('performanceEnabled');
		}

		getAPI() {
			return APIFactory.createAPI(this, [PerformanceAPI]);
		}

		activateIPA() {
			this._ipaActive = true;
		}

		deactivateIPA() {
			this._ipaActive = false;
		}

		isIPAActive() {
			return this._ipaActive;
		}
	}

	return Performance;
});